<template>
  <div>
    <h6>■職種設定</h6>
    <job-content-table :title="offerPointTitle">
      <job-content-table-outline
        v-if="!isCompanyStaffAccess"
        title="給与コード"
        :target-id="targetIdMap.categorySetting.point.salaryCode"
        :value="jobCategorySettings.offerPoint.salary"
        :comment-highlights="getCommentHighlights(targetIdMap.categorySetting.point.salaryCode)"
        :highlight-mode="highlightMode"
        v-on="$listeners"
      />
      <job-content-table-outline
        title="職種[1]"
        :target-id="`${targetIdMap.categorySetting.point.jobName}-1`"
        :value="jobCategorySettings.offerPoint.jobName1"
        :comment-highlights="getCommentHighlights(`${targetIdMap.categorySetting.point.jobName}-1`)"
        :highlight-mode="highlightMode"
        v-on="$listeners"
      />
      <job-content-table-outline
        title="職種[2]"
        :target-id="`${targetIdMap.categorySetting.point.jobName}-2`"
        :value="jobCategorySettings.offerPoint.jobName2"
        :comment-highlights="getCommentHighlights(`${targetIdMap.categorySetting.point.jobName}-2`)"
        :highlight-mode="highlightMode"
        v-on="$listeners"
      />
      <job-content-table-outline
        v-if="!isCompanyStaffAccess"
        title="対象学歴"
        :target-id="targetIdMap.categorySetting.point.education"
        :value="jobCategorySettings.offerPoint.educationTarget"
        :comment-highlights="getCommentHighlights(targetIdMap.categorySetting.point.education)"
        :highlight-mode="highlightMode"
        v-on="$listeners"
      />
      <job-content-table-outline
        v-if="!isCompanyStaffAccess"
        title="年齢"
        :target-id="targetIdMap.categorySetting.point.age"
        :value="jobCategorySettings.offerPoint.ageFromTo"
        :comment-highlights="getCommentHighlights(targetIdMap.categorySetting.point.age)"
        :highlight-mode="highlightMode"
        v-on="$listeners"
      >
        <br>
        <a @click="openBossSAgeRegulation">［PDF］年齢制限の禁止について</a>
      </job-content-table-outline>
      <job-content-table-outline
        v-if="!isCompanyStaffAccess"
        title="年収"
        :target-id="targetIdMap.categorySetting.point.salary"
        :value="jobCategorySettings.offerPoint.annualIncomeFromTo"
        :comment-highlights="getCommentHighlights(targetIdMap.categorySetting.point.salary)"
        :highlight-mode="highlightMode"
        v-on="$listeners"
      />
      <job-content-table-outline
        title="外部表示用職種名"
        :target-id="targetIdMap.categorySetting.point.externalJobName"
        :value="jobCategorySettings.offerPoint.externalJobName"
        :comment-highlights="getCommentHighlights(targetIdMap.categorySetting.point.externalJobName)"
        :highlight-mode="highlightMode"
        v-on="$listeners"
      />
    </job-content-table>

    <job-content-table title="会社について">
      <job-content-table-outline
        title="正式社名"
        :target-id="targetIdMap.categorySetting.about.formalName"
        :value="jobCategorySettings.aboutCompany.formalName"
        :comment-highlights="getCommentHighlights(targetIdMap.categorySetting.about.formalName)"
        :highlight-mode="highlightMode"
        v-on="$listeners"
      >
        <br>
        <span class="notice">※支店名、事業部名、グループ名等の入力不可。</span>
        <span
          v-if="jobCategorySettings.aboutCompany.isVisibleInGoogle"
          class="notice"
          data-test="isVisibility"
        >※提携サイト掲載時にこちらの社名が使用されます。</span>
      </job-content-table-outline>
      <job-content-table-outline
        title="表示用社名"
        :target-id="targetIdMap.categorySetting.about.displayName"
        :value="jobCategorySettings.aboutCompany.displayName"
        :comment-highlights="getCommentHighlights(targetIdMap.categorySetting.about.displayName)"
        :highlight-mode="highlightMode"
        v-on="$listeners"
      >
        <br>
        <span
          v-if="!jobCategorySettings.aboutCompany.isVisibleInGoogle"
          class="notice"
        >※提携サイト掲載時にこちらの社名が使用されます。</span>
      </job-content-table-outline>
      <job-content-table-outline
        title="業種名"
        :target-id="targetIdMap.categorySetting.about.businessName"
        :value="jobCategorySettings.aboutCompany.businessName"
        :comment-highlights="getCommentHighlights(targetIdMap.categorySetting.about.businessName)"
        :highlight-mode="highlightMode"
        v-on="$listeners"
      />
    </job-content-table>

    <job-content-table title="設定済PRコード一覧">
      <template
        v-if="!isCompanyStaffAccess"
        #title
      >
        (<a @click="openBossSPRCodes()">すべてのPRコード</a>)
      </template>
      <template #default>
        <job-content-table-outline
          title="アピールポイント"
          :target-id="targetIdMap.categorySetting.pr.normal"
          :value="jobCategorySettings.configuredPrContents.normalPrContents"
          :comment-highlights="getCommentHighlights(targetIdMap.categorySetting.pr.normal)"
          :highlight-mode="highlightMode"
          v-on="$listeners"
        />
        <job-content-table-outline
          title="特集用検索コード"
          :target-id="targetIdMap.categorySetting.pr.ura"
          :value="jobCategorySettings.configuredPrContents.uraPrContents"
          :comment-highlights="getCommentHighlights(targetIdMap.categorySetting.pr.ura)"
          :highlight-mode="highlightMode"
          v-on="$listeners"
        />
        <job-content-table-outline
          title="エンジニア系特集用検索コード"
          :target-id="targetIdMap.categorySetting.pr.uraEngineer"
          :value="jobCategorySettings.configuredPrContents.uraEngineerPrContents"
          :comment-highlights="getCommentHighlights(targetIdMap.categorySetting.pr.uraEngineer)"
          :highlight-mode="highlightMode"
          v-on="$listeners"
        />
        <job-content-table-outline
          title="サービス・販売系特集用検索コード"
          :target-id="targetIdMap.categorySetting.pr.uraService"
          :value="jobCategorySettings.configuredPrContents.uraServicePrContents"
          :comment-highlights="getCommentHighlights(targetIdMap.categorySetting.pr.uraService)"
          :highlight-mode="highlightMode"
          v-on="$listeners"
        />
      </template>
    </job-content-table>

    <job-content-table title="専用応募フォーム">
      <job-content-table-outline
        title="設定URL"
        :target-id="targetIdMap.categorySetting.applyUrl"
        :value="jobCategorySettings.applyUrl"
        :comment-highlights="getCommentHighlights(targetIdMap.categorySetting.applyUrl)"
        :highlight-mode="highlightMode"
        v-on="$listeners"
      >
        <template
          v-if="jobCategorySettings.applyUrl"
          #body
        >
          <component
            :is="tag"
            :id="targetIdMap.categorySetting.applyUrl"
            :href="jobCategorySettings.applyUrl"
            :class="{'pega-anchor-text':highlightMode}"
            class="pega-break text-underline"
            rel="nofollow"
            target="blank"
            data-test="value"
            v-text="jobCategorySettings.applyUrl"
          />
        </template>
      </job-content-table-outline>
    </job-content-table>

    <job-content-table :title="questionTitle">
      <job-content-table-outline
        v-for="index in [1,2,3]"
        :key="`question-${index}`"
        :title="`独自質問${index}`"
        :target-id="`${targetIdMap.categorySetting.question}-${index}`"
        :value="questionItems[`question${index}`]"
        :comment-highlights="getCommentHighlights(`${targetIdMap.categorySetting.question}-${index}`)"
        :highlight-mode="highlightMode"
        v-on="$listeners"
      />
    </job-content-table>

    <job-content-table title="情報提供">
      <job-content-table-outline
        title="外部連携データ"
        :target-id="targetIdMap.categorySetting.provided"
        :value="jobCategorySettings.providedInfo"
        :comment-highlights="getCommentHighlights(targetIdMap.categorySetting.provided)"
        :highlight-mode="highlightMode"
        v-on="$listeners"
      />
    </job-content-table>
  </div>
</template>

<script>
import JobContentTable from '@/components/atoms/JobContentTable'
import JobContentTableOutline from '@/components/atoms/JobContentTableOutline'
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import jobPreviewHighlight from '@/lib/jobPreviewHighlight'
import jobPreviewUrlHighlight from '@/lib/jobPreviewUrlHighlight'

export default {
  components: {
    JobContentTable,
    JobContentTableOutline
  },
  mixins: [jobPreviewCommon, jobPreviewHighlight, jobPreviewUrlHighlight],
  props: {
    jobCategorySettings: {
      type: Object,
      required: true
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    highlightMode: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    urlHighlightTargetIds () {
      return [this.targetIdMap.categorySetting.applyUrl]
    }
  }
}
</script>
